module.exports = __webpack_public_path__ + "img/TourBanner.e795726a.png";